export default __webpack_public_path__ + "media/zurb/img/mobile-and-web-apps/monster-3-1312a4a2051ff15209c7654d60290e1e.png";